import { Link } from "react-router-dom";

const ToDo = ({ children }) => (
  <span style={{ background: "var(--warn-soft)", color: "var(--warn)", fontWeight: 700, padding: "0 0.3rem", borderRadius: 4 }}>
    À COMPLÉTER — {children}
  </span>
);

export default function MentionsLegales() {
  return (
    <div data-testid="screen-mentions" style={{ maxWidth: 640 }}>
      <h1 style={{ fontSize: "1.6rem" }}>Mentions légales</h1>

      <h2 style={{ fontSize: "1.1rem", marginTop: "1.2rem" }}>Éditeur du service</h2>
      <p>
        Élodie Perrichon, entrepreneur individuel (EI)<br />
        SIRET : 80799892700048<br />
        Adresse : Les Tricolores, 6 rue d'Armaillé, 75017 Paris<br />
        Activité déclarée : édition de revue, presse et blog<br />
        TVA non applicable, article 293 B du CGI
      </p>

      <h2 style={{ fontSize: "1.1rem", marginTop: "1.2rem" }}>Directrice de la publication</h2>
      <p>Élodie Perrichon</p>

      <h2 style={{ fontSize: "1.1rem", marginTop: "1.2rem" }}>Contact</h2>
      <p><a href="mailto:contact@preavis-catnat.fr">contact@preavis-catnat.fr</a></p>

      <h2 style={{ fontSize: "1.1rem", marginTop: "1.2rem" }}>Hébergeur</h2>
      <p>
        Agione Technologies Private Limited (plateforme Emergent)<br />
        B-1103, Salarpuria Sattva Magnificia, Tin Factory, Krishnarajapuram R.S.,
        Bangalore, KA 560016, Inde<br />
        Téléphone : <ToDo>numéro de téléphone de l'hébergeur</ToDo>
      </p>

      <h2 style={{ fontSize: "1.1rem", marginTop: "1.2rem" }}>Indépendance</h2>
      <p style={{ fontWeight: 600 }}>
        Préavis CatNat est un service indépendant. Il n'a aucun lien avec l'État, une administration
        publique, un assureur ou un courtier en assurance. Il ne se substitue à aucune démarche officielle.
      </p>
      <p style={{ color: "var(--muted)" }}>Service gratuit et sans publicité.</p>

      <p style={{ marginTop: "1.4rem" }}><Link to="/" data-testid="mentions-home">Retour à l'accueil</Link></p>
    </div>
  );
}
